import { sanitizeFileName } from "./genericUtilityFunctions";

export const DEFAULT_EXPORT_PROJECT_NAME = "Untitled Project";

export function sanitizeExportSegment(value?: string | null): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    return "";
  }

  const sanitized = sanitizeFileName(trimmed);
  return sanitized?.trim() ?? "";
}

export function sanitizeExportProjectName(name?: string | null): string {
  return sanitizeExportSegment(name) || DEFAULT_EXPORT_PROJECT_NAME;
}

export function buildExportFilename(options: {
  projectName?: string | null;
  exportType: string;
  variant?: string | null;
  extension?: string;
}): string {
  const { projectName, exportType, variant, extension } = options;

  const segments = [
    sanitizeExportProjectName(projectName),
    sanitizeExportSegment(exportType) || "export",
  ];

  const variantSegment = sanitizeExportSegment(variant);
  if (variantSegment) {
    segments.push(variantSegment);
  }

  segments.push("RivetAI");

  const base = segments.join(" - ");
  if (!extension) {
    return base;
  }

  const normalizedExtension = extension.replace(/^\./, "").toLowerCase();
  return `${base}.${normalizedExtension}`;
}
